export const RequiredAsterisk = () => (
  <span className="font-inter-semibold-13px text-indigo-500">*</span>
);
